import { Spin } from 'antd'
import { COLORS } from 'app/constants'
import { useCurrency } from 'app/hooks/trade/useCurrency'
import BigNumber from 'bignumber.js'
import React from 'react'
import { Text, View } from 'styles/reactnative'
import { useExchangeStore } from '../../hooks/trade/exchangeStore'
import { useIndexPrice } from '../../hooks/trade/indexprice'

const Unrealizedplpercent = ({ data }) => {
	let { getPrice } = useIndexPrice(data?.exchange_pairs_id)
	let { EPs } = useExchangeStore()
	let EP = EPs?.find((item: any) => item?.id === data?.exchange_pairs_id)

	let pnl = 0

	const currentprice = getPrice(data?.exchange_pairs_id)
	const { krwrate, getRate } = useCurrency()
	const currencyrate = getRate(EP?.currency)

	const rate = BigNumber(krwrate?.price || 0)
		.div(currencyrate?.price || 0)
		.toNumber()

	if (data?.long_short === 'L') {
		pnl = BigNumber(currentprice)
			.minus(data?.price)
			.multipliedBy(data?.amount)
			.multipliedBy(EP?.contractamt)
			.multipliedBy(rate)
			.toNumber()
	} else {
		pnl = BigNumber(data?.price)
			.minus(currentprice)
			.multipliedBy(data?.amount)
			.multipliedBy(EP?.contractamt)
			.multipliedBy(rate)
			.toNumber()
	}

	if (currentprice === 0) {
		return <Spin />
	}

	return (
		<View
			style={{
				whiteSpace: 'nowrap',
				lineHeight: 1,
				flexDirection: 'column',
				alignContent: 'center',
				alignItems: 'flex-end',
			}}>
			<Text
				style={{
					fontSize: 13,
					whiteSpace: 'nowrap',
					color:
						pnl > 0
							? COLORS.lightGreen
							: pnl < 0
							? COLORS.lightRed
							: '#000',
				}}>
				{pnl > 0 ? '+' : ''}
				{BigNumber(pnl).toFormat(0)}원
			</Text>
			<Text
				style={{
					fontSize: 11,
					whiteSpace: 'nowrap',
					color:
						pnl > 0
							? COLORS.lightGreen
							: pnl < 0
							? COLORS.lightRed
							: '#000',
				}}></Text>
		</View>
	)
}

export default Unrealizedplpercent
